import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "../../../utils/router";
import { apiRequest } from "../../../hooks/apiRequest";
import { getLink, objectToFormData, toast } from "../../../utils/helpers";
import Loader from "../../general/Loader";
import ContactoEmergencia from "./Components/ContactoEmergencia";
import Chips from "../Visitas/Components/Chips";
import VisitasComponent from "../Components/Visitas";
import { postRequest } from "../../../utils/request";
import { apiUrl } from "../../../utils/apiUrl";
import { debounce } from "lodash";
import PacienteableInfo from "../Components/PacienteableInfo";
import { Link } from "react-router-dom";

const View = () => {
    const { id } = useParams();
    const history = useHistory();

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [paciente, setPaciente] = useState({});
    const [original, setOriginal] = useState({});

    const getPaciente = async () => {
        const response = await apiRequest({}, `salud/pacientes/${id}`, 'get');

        if (response.success) {
            setPaciente(response.data);
            setOriginal(response.data);
        } else {
            toast('Error obteniendo la visita', 'error');
            history.push(getLink("/salud/paciente"))
        }

        setLoading(false);
    };

    const saveChange = debounce(async (item) => {
        setSaving(true);

        const data = objectToFormData({...item, "_method": "put"});
        
        const response = await postRequest(apiUrl(`salud/pacientes/${id}`), data);

        if (response.success) {
            setOriginal(item);
        } else {
            setPaciente(original);
        }

        if (response.code === 422) {
            toast(response.data.message);
        }
        
        setSaving(false);
    }, 500);

    const onChange = async (item) => {
        setPaciente(item);

        saveChange(item);
    };

    useEffect(() => {
        getPaciente();
    }, []);

    if (loading) return <Loader></Loader>;

    return <>
        <div className="card px-3 py-4" style={{borderRadius: '8px', minHeight: '100%'}}>
            <div className="row">
                <Link to={getLink('/salud/pacientes')} className="ml-3 mr-0">&laquo; Volver a pacientes</Link>
                <div className="flex flex-column" style={{ width: "calc(100% - 300px)"}}>
                    <h1 className="text-center mx-auto">Historial del Paciente</h1>
                    <small className="text-center mx-auto mb-2 my-0 text-info">Hacer click en los iconos para editar la información</small>
                </div>

                {saving && <div className="ml-auto mr-3"> <Loader type='small' /></div>}
            </div>

            <div className="row">
                <div className="col-12 col-md-6">
                    <div className="row  px-4 py-2">
                        <div style={{width: '70px'}} className="mx-2">
                            <span className="page-title-foto m-0">
                                <img src={paciente.foto ?? '/images/icon/avatar.png'} />
                            </span>
                        </div>

                        <div className="col p-0">
                            <h3 className="mt-2 mb-auto" style={{fontSize: '18px'}}>{ paciente.nombre_completo }</h3>

                            <span>Tipo de contacto: <strong>{paciente.tipo}</strong></span>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="row  px-4 py-2">
                        <PacienteableInfo
                            paciente={paciente}
                            disabled={saving}
                            onChange={onChange}
                        ></PacienteableInfo>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-6">
                    <div className="row px-4">
                        <div className="col">
                            <h4>Código</h4>
                            <span>{paciente.codigo}</span>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="row px-4">
                        <div className="col">
                            <h4>Contacto Emergencia</h4>
                            <ContactoEmergencia
                                value={paciente.contacto_emergencia ?? {}}
                                disabled={saving}
                                onChange={(contacto_emergencia) => onChange({
                                        ...paciente,
                                        contacto_emergencia
                                    })
                                }
                            ></ContactoEmergencia>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-6">
                    <div className="row px-4">
                        <div className="col">
                            <h4>Alergias</h4>
                            <Chips
                                values={paciente.alergias}
                                disabled={saving}
                                onChange={(alergias) => onChange({
                                    ...paciente,
                                    alergias
                                })}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="row px-4">
                        <div className="col">
                            <h4>Condiciones Medicas</h4>
                            <Chips
                                values={paciente.condiciones_medicas}
                                disabled={saving}
                                onChange={(condiciones_medicas) => onChange({
                                    ...paciente,
                                    condiciones_medicas
                                })}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="card px-3 py-4" style={{borderRadius: '8px', minHeight: '100%'}}>
            <VisitasComponent paciente_id={id} />
        </div>
    </>;
};

export default View;
